var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.0242V8.99922H7.6C7.71667 8.99922 7.83333 9.01172 7.95 9.03672C8.06667 9.06172 8.18333 9.09089 8.3 9.12422L15.225 11.6992C15.4583 11.7826 15.6458 11.9326 15.7875 12.1492C15.9292 12.3659 16 12.5909 16 12.8242C16 13.1742 15.8792 13.4576 15.6375 13.6742C15.3958 13.8909 15.1167 13.9992 14.8 13.9992H12.175C12.0917 13.9992 12.0292 13.9951 11.9875 13.9867C11.9458 13.9784 11.8917 13.9576 11.825 13.9242L10.225 13.2992L9.9 14.2742L11.825 14.9492C11.8583 14.9659 11.9083 14.9784 11.975 14.9867C12.0417 14.9951 12.1 14.9992 12.15 14.9992H19C19.5333 14.9992 20 15.1909 20.4 15.5742C20.8 15.9576 21 16.4326 21 16.9992L13.025 19.9992L6 18.0242ZM0 19.9992V8.99922H4V19.9992H0ZM11.925 9.04922L7.675 4.79922L9.1 3.39922L11.925 6.22422L17.6 0.574219L19 1.97422L11.925 9.04922Z",
    fill: "#1E972A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabReceived);
export default __webpack_public_path__ + "static/media/LabReceived.ce3201e29f637310ca03e0bba6ec1109.svg";
export { ForwardRef as ReactComponent };